import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you provide website design services in Kochi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer professional website design, development, SEO, and digital marketing services in Kochi for businesses and individuals."
      }
    },
    {
      "@type": "Question",
      "name": "What is the starting cost for a website in Kochi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The basic website design package starts from ₹10,000. The price depends on features like design, number of pages, and functionalities."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all websites we design are fully responsive and compatible with mobile, tablet, and desktop devices."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included in your web design services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our packages include basic on-page SEO such as meta tags, keywords, alt text, sitemap, and schema markup."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update the website content myself?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we develop websites on user-friendly CMS platforms like WordPress, allowing you to update content and images easily."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer eCommerce website development in Kochi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we develop eCommerce websites using WooCommerce, Shopify, or custom solutions with full payment integration and product management."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic business website can be completed in 5–7 days. Custom or eCommerce websites may take 2–4 weeks based on features and complexity."
      }
    },
    {
      "@type": "Question",
      "name": "Do you help with domain and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we assist with domain registration, hosting setup, SSL configuration, and professional email setup."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer maintenance services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide ongoing website maintenance including content updates, backups, performance monitoring, and security checks."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with your web services in Kochi?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact us through our website or call us. We will discuss your requirements and start your project quickly."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Kochi</title>
<meta name="description" content="Top website designer in Kochi. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="web design company cochin, website design company ernakulam, website development company in kochi, website designers in cochin, website designer in kochi, best web designers in kochi, website designer in ernakulam, web development company kochi, web designers in kochi, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Kochi" />
<meta property="og:description" content="Top Website Designer In Kochi. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Kochi" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-kochi"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Kochi" />
<meta name="twitter:description" content="Top website designer in Kochi. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-kochi" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer In Kochi</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Kochi</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Welcome to Pankaj's Web Design Services! Situated in the picturesque city of Kochi, I specialize in creating visually stunning and highly functional websites tailored to meet the unique needs of businesses and individuals. My mission is to deliver websites that not only capture attention but also provide an excellent user experience and drive results.
<h3>My Services:</h3>
<h4><strong>Custom Website Design</strong></h4>
Every business is unique, and I believe your website should reflect that. I create custom website designs that embody your brand’s identity and cater to your specific audience. Whether you need a professional corporate site, a creative portfolio, or a dynamic e-commerce platform, I’ll work closely with you to bring your vision to life.
<h4><strong>E-Commerce Solutions</strong></h4>
Are you ready to expand your business online? I provide comprehensive e-commerce solutions that empower you to launch and manage your online store effortlessly. My e-commerce websites feature user-friendly interfaces, secure payment gateways, and attractive product displays to enhance the shopping experience for your customers.
<h4><strong>Responsive Web Development</strong></h4>
In today’s mobile-driven world, having a responsive website is essential. I ensure that all websites I design are fully responsive, providing a seamless experience across all devices, including desktops, tablets, and smartphones. This adaptability ensures that your visitors can access your site easily, no matter how they connect.
<h4><strong>SEO-Friendly Websites</strong></h4>
To succeed online, your website must be easily discoverable. I implement SEO best practices during the design process to enhance your site's visibility on search engines. This includes optimizing your content, images, and site structure to attract organic traffic and improve your rankings.
<h4><strong>Website Redesign</strong></h4>
If your current website feels outdated or isn't meeting your expectations, I offer website redesign services to revitalize your online presence. My goal is to create a modern, user-friendly design that enhances functionality and aligns with your current business objectives.
<h4><strong>Content Management Systems (CMS)</strong></h4>
I use popular content management systems like WordPress, enabling you to manage your website content with ease. With a user-friendly interface, you can make updates and changes independently, allowing you to maintain full control over your site.
<h4><strong>Maintenance &amp; Support</strong></h4>
After your website is live, I offer ongoing maintenance and support services to ensure everything runs smoothly. From regular updates to troubleshooting, I’m here to assist you with any issues that may arise, ensuring your website remains effective and up-to-date.
<h4><strong>Digital Marketing &amp; SEO Services</strong></h4>
In addition to web design, I provide basic digital marketing services to enhance your online presence. Whether through social media marketing, email campaigns, or content strategies, I can help you effectively reach and engage your target audience.
<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience</strong>: With over ten years of experience in web design and development, I am committed to delivering high-quality results that meet your needs.</li>
  <li><strong>Client-Centric Approach</strong>: I prioritize understanding your vision and objectives, ensuring that the final product exceeds your expectations.</li>
  <li><strong>Affordable Pricing</strong>: I believe in providing quality services at competitive rates that fit your budget.</li>
  <li><strong>Timely Delivery</strong>: I am dedicated to delivering projects on time without compromising quality.</li>
</ul>
Let’s collaborate to create a stunning website that elevates your brand and engages your audience. Contact me today for a consultation and a free quote!

Welcome to Pankaj's Web Design Services! Situated in the picturesque city of Kochi, I specialize in creating visually stunning and highly functional websites tailored to meet the unique needs of businesses and individuals. My mission is to deliver websites that not only capture attention but also provide an excellent user experience and drive results.
<h3>My Services:</h3>
<h4><strong>Custom Website Design</strong></h4>
Every business is unique, and I believe your website should reflect that. I create custom website designs that embody your brand’s identity and cater to your specific audience. Whether you need a professional corporate site, a creative portfolio, or a dynamic e-commerce platform, I’ll work closely with you to bring your vision to life.
<h4><strong>E-Commerce Solutions</strong></h4>
Are you ready to expand your business online? I provide comprehensive e-commerce solutions that empower you to launch and manage your online store effortlessly. My e-commerce websites feature user-friendly interfaces, secure payment gateways, and attractive product displays to enhance the shopping experience for your customers.
<h4><strong>Responsive Web Development</strong></h4>
In today’s mobile-driven world, having a responsive website is essential. I ensure that all websites I design are fully responsive, providing a seamless experience across all devices, including desktops, tablets, and smartphones. This adaptability ensures that your visitors can access your site easily, no matter how they connect.
<h4><strong>SEO-Friendly Websites</strong></h4>
To succeed online, your website must be easily discoverable. I implement SEO best practices during the design process to enhance your site's visibility on search engines. This includes optimizing your content, images, and site structure to attract organic traffic and improve your rankings.
<h4><strong>Website Redesign</strong></h4>
If your current website feels outdated or isn't meeting your expectations, I offer website redesign services to revitalize your online presence. My goal is to create a modern, user-friendly design that enhances functionality and aligns with your current business objectives.
<h4><strong>Content Management Systems (CMS)</strong></h4>
I use popular content management systems like WordPress, enabling you to manage your website content with ease. With a user-friendly interface, you can make updates and changes independently, allowing you to maintain full control over your site.
<h4><strong>Maintenance &amp; Support</strong></h4>
After your website is live, I offer ongoing maintenance and support services to ensure everything runs smoothly. From regular updates to troubleshooting, I’m here to assist you with any issues that may arise, ensuring your website remains effective and up-to-date.
<h4><strong>Digital Marketing &amp; SEO Services</strong></h4>
In addition to web design, I provide basic digital marketing services to enhance your online presence. Whether through social media marketing, email campaigns, or content strategies, I can help you effectively reach and engage your target audience.
<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience</strong>: With over ten years of experience in web design and development, I am committed to delivering high-quality results that meet your needs.</li>
  <li><strong>Client-Centric Approach</strong>: I prioritize understanding your vision and objectives, ensuring that the final product exceeds your expectations.</li>
  <li><strong>Affordable Pricing</strong>: I believe in providing quality services at competitive rates that fit your budget.</li>
  <li><strong>Timely Delivery</strong>: I am dedicated to delivering projects on time without compromising quality.</li>
</ul>
Let’s collaborate to create a stunning website that elevates your brand and engages your audience. Contact me today for a consultation and a free quote!
<h2>Frequently Asked Questions</h2>

<h4>1. What services do you offer as a website designer?</h4>
<p>I offer a range of services, including custom website design, e-commerce solutions, responsive web development, SEO-friendly websites, website redesign, CMS implementation, ongoing maintenance and support, and digital marketing services.</p>

<h4>2. How long does it usually take to design and develop a website?</h4>
<p>The timeline for designing and developing a website can vary based on its complexity and your specific requirements. Typically, a basic website can take around 2-4 weeks, while more complex projects may take longer. I will provide a detailed timeline during our initial consultation.</p>

<h4>3. Are your websites optimized for mobile devices?</h4>
<p>Yes! All websites I create are fully responsive, ensuring they look great and function properly on all devices, including desktops, tablets, and smartphones. This guarantees an excellent user experience for all visitors.</p>

<h4>4. Can you help with SEO for my website?</h4>
<p>Definitely! I incorporate SEO best practices throughout the design process to enhance your site's visibility on search engines. This includes optimizing your content, images, and website structure to attract organic traffic.</p>

<h4>5. Do you provide support after the website goes live?</h4>
<p>Yes, I offer ongoing maintenance and support services to ensure your website runs smoothly after launch. This includes regular updates, troubleshooting, and assistance with any issues that may arise.</p>

<h4>6. How can I update my website after it’s launched?</h4>
<p>If you choose a Content Management System (CMS) like WordPress, you'll have the ability to manage your website content independently. I will provide training on how to make updates, and I'm always available for additional support as needed.</p>

<h4>7. What is the cost of your website design services?</h4>
<p>The cost of my website design services varies based on factors like project complexity, required features, and your specific needs. I provide a free quote after discussing your project details to ensure it fits your budget.</p>

<h4>8. Can you redesign my existing website?</h4>
<p>Yes, I offer website redesign services to refresh and improve your current site. This can include updating the layout, enhancing functionality, and optimizing for better performance and user experience.</p>

<h4>9. How do we get started on a project?</h4>
<p>To begin, simply contact me through my website or reach out via email or phone. We’ll schedule a consultation to discuss your project goals, timeline, and budget, allowing us to create a tailored plan for your website.</p>

<h4>10. Why should I choose you as my website designer?</h4>
<p>With over ten years of experience, a client-centric approach, and a commitment to delivering high-quality results on time, I am dedicated to helping you create a website that meets your needs and exceeds your expectations. Your satisfaction is my top priority!</p>

          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
